module.exports = {
	"projects": {
		"default": "refire"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.firebaserc
// module id = 1009
// module chunks = 0